export const MediumRectangleIcon = ({ size = 16, color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect x="3" y="4.5" width="18" height="15" rx="1.5" stroke={color} strokeWidth="1.5" />
    <rect x="9" y="9.125" width="6" height="1.5" rx="0.75" fill={color} />
    <rect x="7.5" y="11.625" width="9" height="1.5" rx="0.75" fill={color} />
    <rect x="10.125" y="14.125" width="3.75" height="1.5" rx="0.75" fill={color} />
  </svg>
)

// The halfpage and billboard marks are drawn at a fixed `box`; `size` was never applied to them.
export const HalfpageIcon = ({ box = 20, color = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={box} height={box} viewBox="0 0 24 24" fill="none">
    <rect x="7.125" y="2.25" width="9.75" height="19.5" rx="1.5" stroke={color} strokeWidth="1.5" />
    <rect x="10.5" y="9.75" width="3" height="1.5" rx="0.75" fill={color} />
    <rect x="10.5" y="12.75" width="3" height="1.5" rx="0.75" fill={color} />
  </svg>
)

export const BilloardIcon = ({ box = 20, color = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={box} height={box} viewBox="0 0 24 24" fill="none">
    <rect x="2.25" y="8" width="19.5" height="8.25" rx="1.5" stroke={color} strokeWidth="1.5" />
    <rect x="7.5" y="11.34" width="9" height="1.5" rx="0.75" fill={color} />
  </svg>
)
